<div>
  <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <!-- Podvrsta dokumenta -->
          <div class="col-md-2">
            <div class="form-group row">
              <div class="col-md-12 col-12">
                <yt-dropdown-picklist 
                  [ModelName]="'podvrstadokumentastavka'" 
                  [GetName]="'GetByUrl'" 
                  [ModelProperty]="'Sifra,Naziv'"
                  [GetParameters]="modelData.MainList.GetParameters" 
                  formControlName="PodVrstaDokumentaStavkaID"
                  [Label]="'KOZDOKUMENT.PODVRSTADOKUMENTASTAVKA.SINGULAR'" 
                  [ngClass]="{'is-invalid': submitted && fc.PodVrstaDokumentaStavkaID.invalid}"
                  (OnItemSelected)='onPodVrstaSelect()' 
                  [Width]="'600px'"
                  #autofocus>
                </yt-dropdown-picklist>
              </div>
              <div class="form-error" *ngIf="submitted && fc.PodVrstaDokumentaStavkaID.invalid">
                <span *ngFor="let validation of errorMessages.PodVrstaDokumentaStavkaID">
                  <span class="error-message" *ngIf="fc.PodVrstaDokumentaStavkaID.hasError(validation.type)">
                    <span translate="{{validation.message}}"></span>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <!-- Datum dokumenta -->
          <div class="col-md-2 col-12">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-fw-date-picker-popup 
                  formControlName="Datum" 
                  name="txtDatum" 
                  [Label]="'KOZDOKUMENT.DATUM.SINGULAR'"
                  [ngClass]="{'is-invalid': submitted && fc.Datum.invalid}" 
                  (OnDateSelected)="onDatumChange($event)">
                </yt-fw-date-picker-popup>
              </div>
              <div class="form-error" *ngIf="submitted && fc.Datum.invalid">
                <span *ngFor="let validation of errorMessages.Datum">
                  <span class="error-message" *ngIf="fc.Datum.hasError(validation.type)">
                    <span translate="{{validation.message}}"></span>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <!-- Broj dokumenta -->
          <div class="col-md-2 col-12">
            <div class="form-group row">
              <div class="col-md-8 col-8">
                <yt-input 
                  [Type]="'text'" 
                  [Label]="'KOZDOKUMENT.BROJDOKUMENTA.SINGULAR'" 
                  formControlName="Broj"
                  [ngClass]="{'is-invalid': submitted && fc.Broj.invalid}">
                </yt-input>
              </div>
              <div class="form-error" *ngIf="submitted && fc.Broj.invalid">
                <span *ngFor="let validation of errorMessages.Broj">
                  <span class="error-message" *ngIf="fc.Broj.hasError(validation.type)">
                    <span translate="{{validation.message}}"></span>
                  </span>
                </span>
              </div>
              <div class="col-md-4 col-4">
                <div class="input-group-append">
                  <span class="span-control">/</span>
                  <span *ngIf="baseFormGroup.get('Datum').value != null" class="span-control">{{baseFormGroup.get('Datum').value.year}}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- Komitent -->
          <div class="col-md-3">
            <div class="form-group row">
              <div class="col-md-12 col-12">
                <yt-dropdown-picklist 
                  [ModelName]="'komitent'" 
                  [GetName]="'get'" 
                  [ModelProperty]="'SNaziv'" 
                  [OrderBy]="'SNaziv'"
                  [AllowAddNew]="true" 
                  formControlName="KomitentID" 
                  [Label]="'KOZDOKUMENT.KOMITENT.SINGULAR'" 
                  [Width]="'600px'"
                  >
                </yt-dropdown-picklist>
              </div>
              <div class="form-error" *ngIf="submitted && fc.KomitentID.invalid">
                <span *ngFor="let validation of errorMessages.KomitentID">
                  <span class="error-message" *ngIf="fc.KomitentID.hasError(validation.type)">
                    <span translate="{{validation.message}}"></span>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <!--Tarifa-->
          <div class="col-md-3">
            <div class="form-group row">
              <div class="col-md-12 col-12">
                <yt-dropdown-picklist 
                  [ModelName]="'tarifa'" 
                  [GetName]="'get'" 
                  [ModelProperty]="'Naziv'" 
                  [OrderBy]="'Naziv'"
                  [AllowAddNew]="false" 
                  formControlName="TarifaID" 
                  [Label]="'KOZDOKUMENT.TARIFA.SINGULAR'" 
                  [Width]="'450px'">
                </yt-dropdown-picklist>
              </div>
              <div class="form-error" *ngIf="submitted && fc.TarifaID.invalid">
                <span *ngFor="let validation of errorMessages.TarifaID">
                  <span class="error-message" *ngIf="fc.TarifaID.hasError(validation.type)">
                    <span translate="{{validation.message}}"></span>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <!-- Napomena -->
          <div class="col-md-12">
            <div class="form-group row">
              <div class="col-md-12 col-12">
                <yt-text-area 
                  name="txtNapomena" 
                  formControlName="Napomena" 
                  [Label]="'KOZDOKUMENT.NAPOMENA.SINGULAR'"
                  [MaxLength]="500">
                </yt-text-area>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <yt-koz-dokument-stavka-update-container 
          [DetailModelData]="modelData.MainList.DetailList[0]"
          [ParentPropertyName]="'KozDokumentID'" 
          [ParentPropertyValue]="Item.ID">
        </yt-koz-dokument-stavka-update-container>
      </div>
    </div>
  </form>
</div>